export const multipleOperations = [
  "array-contains",
  "in",
  "not-in",
  "array-contains-any",
];